module.exports = __webpack_public_path__ + "static/media/wuda1.91451bf3.png";